import React, { useState } from "react";
import { useDispatch } from "react-redux";
import "leaflet/dist/leaflet.css";
import "leaflet-gpx";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CustomButton from "../../../components/customButton/customButton";
import "./suggestedTrailDetail.scss";
import { showToast } from "../../../store/features/toast/toastSlice";
import { Carousel, CarouselItem, CarouselIndicators } from "reactstrap";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { SUGGESTED_TRAILS_STATUS } from "../../../api/endPoint";
import imagePlaceholder from "../../../assets/images/tottPlaceholder.svg";
import { getCloudinaryOtherImageUrl } from "../../../util/cloudinaryUpload";
import { format, parseISO } from "date-fns";
import { Helmet } from "react-helmet";

const SuggestedTrailDetail: React.FC = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const pendingTrailData = location?.state?.pendingTrailData;
  const rejectedTrailData = location?.state?.rejectedTrailData;
  const acceptedTrailData = location?.state?.acceptedTrailData;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [btnLoading, setBtnLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = (newIndex: number) => {
    if (animating) return;
    setActiveIndex(newIndex);
  };
  const items =
    (
      pendingTrailData?.otherImages ||
      rejectedTrailData?.otherImages ||
      acceptedTrailData?.other_images ||
      []
    ).length > 0
      ? (
          pendingTrailData?.otherImages ||
          rejectedTrailData?.otherImages ||
          acceptedTrailData?.other_images ||
          []
        ).map((image: any, index: number) => ({
          src: image ? getCloudinaryOtherImageUrl(image) : imagePlaceholder,
          altText: `Slide ${index + 1}`,
          caption: `Slide ${index + 1}`,
          key: index + 1,
        }))
      : [
          {
            src: imagePlaceholder,
            altText: "No Image Available",
            caption: "No Image Available",
            key: 1,
          },
        ];

  const onRemoveTrail = () => {
    setModal(true);
  };

  const [modal, setModal] = useState(false);

  const cancelModal = () => {
    setModal(false);
  };
  const onAcceptTrail = () => {
    try {
      const formattedTrailData = {
        title: pendingTrailData?.Title || "",
        description: pendingTrailData?.description || "",
        featured_image: pendingTrailData?.featuredImage || "",
        other_images: pendingTrailData?.otherImages || [],
        gpx_file: pendingTrailData?.gpxFile || "",
        gpx_file_link: pendingTrailData?.gpxFileLink || "",
        explain_route_path: pendingTrailData?.explainRoutePath || "",
        trail_type: "",
        route_type: "",
        difficulty: "",
        length: "",
        ascent: "",
        average_time_hours: "",
        average_time_minutes: "",
        towns: "",
        start_latitude: "",
        start_longitude: "",
      };

      navigate("/add-trail", {
        state: {
          mode: "edit",
          trailType: "suggested",
          trailData: formattedTrailData,
          suggestedTrailId: pendingTrailData?.id,
        },
      });
      setLoading(false);
    } catch (error: any) {
      console.error("Error details:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        url: error.config?.url,
      });

      dispatch(
        showToast({
          show: true,
          message:
            error.response?.data?.message ||
            error.message ||
            "Failed to accept trail",
          type: "error",
        })
      );
    } finally {
      setBtnLoading(false);
    }
  };

  const onRemoveModal = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      const response = await axios.patch(
        `${process.env.REACT_APP_API_BASE_URL}${SUGGESTED_TRAILS_STATUS}/${pendingTrailData?.id}`,
        { status: "Rejected" },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        dispatch(
          showToast({
            show: true,
            message: response.data.message,
            type: "success",
          })
        );
        setModal(false);
        navigate("/suggested-trails");
      }
    } catch (error: any) {
      dispatch(
        showToast({
          show: true,
          message: error.response?.data?.message || "Failed to reject trail",
          type: "error",
        })
      );
    } finally {
      setLoading(false);
    }
  };

  const onGpxDownload = () => {
    if (
      pendingTrailData?.gpxFile ||
      rejectedTrailData?.gpxFile ||
      acceptedTrailData?.gpx_file
    ) {
      setBtnLoading(true);
      const gpxUrl = pendingTrailData
        ? `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_NAME}/${process.env.REACT_APP_CLOUDNARY_GPX_FILES_SUBFLODER}/${pendingTrailData?.gpxFile}`
        : rejectedTrailData
        ? `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_NAME}/${process.env.REACT_APP_CLOUDNARY_GPX_FILES_SUBFLODER}/${rejectedTrailData?.gpxFile}`
        : acceptedTrailData
        ? `https://res.cloudinary.com/${process.env.REACT_APP_CLOUDINARY_NAME}/${process.env.REACT_APP_CLOUDNARY_GPX_FILES_SUBFLODER}/${acceptedTrailData?.gpx_file}`
        : "";
      const link = document.createElement("a");
      link.href = gpxUrl;
      link.download = `${pendingTrailData?.title}.gpx`; // Set the desired file name
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      setTimeout(() => {
        dispatch(
          showToast({
            show: true,
            message: "GPX file downloaded successfully.",
            type: "success",
          })
        );
        setBtnLoading(false);
      }, 2000); // 2 seconds delay
    } else {
      if (pendingTrailData?.gpxFileLink) {
        window.open(pendingTrailData?.gpxFileLink, "_blank");
      }
      if (rejectedTrailData?.gpxFileLink) {
        window.open(rejectedTrailData?.gpxFileLink, "_blank");
      }
      if (acceptedTrailData?.gpx_file_link) {
        window.open(acceptedTrailData?.gpx_file_link, "_blank");
      }
    }
  };

  const handleImageError = (e: any) => {
    e.target.src = imagePlaceholder;
  };
  return (
    <>
      <Helmet>
        <title>{`${
          pendingTrailData?.Title ||
          rejectedTrailData?.Title ||
          acceptedTrailData?.title
        } | Town of 1000 Trails Admin Panel`}</title>
        <meta
          name="description"
          content="View trail details and update information about the trail."
        />
      </Helmet>
      <div className="main-container container trailDetailPage">
        <div className="pageTopbar mb-4">
          <div className="leftPart">
            <CustomButton
              type="button"
              className="btn btn-transparent backBtn"
              onClick={() => navigate(-1)}
              title={t("BACK")}
              icon={<span className="icon icon-arrow-left me-2"></span>}
            />
          </div>
          <div className="rightPart">
            {location.state.trailType === "pending" && (
              <>
                <CustomButton
                  type="button"
                  className="btn btn-danger"
                  onClick={onAcceptTrail}
                  title={t("ACCEPT_TRAIL")}
                />
                <CustomButton
                  type="button"
                  className="btn  btn-outline-primary "
                  onClick={onRemoveTrail}
                  title={t("REJECT_TRAIL")}
                  // icon={<span className="icon icon-Cancel me-2"></span>}
                />
              </>
            )}
          </div>
        </div>

        <div className="customScroll">
          <div className="trailContent">
            <div className="leftPart">
              <Carousel
                activeIndex={activeIndex}
                next={next}
                previous={previous}
              >
                <CarouselIndicators
                  items={items}
                  activeIndex={activeIndex}
                  onClickHandler={goToIndex}
                />
                {items.map((item: any) => (
                  <CarouselItem
                    key={item.key}
                    onExiting={() => setAnimating(true)}
                    onExited={() => setAnimating(false)}
                  >
                    <img
                      src={item?.src ? item?.src : imagePlaceholder}
                      alt={item?.altText}
                      onError={handleImageError}
                    />
                  </CarouselItem>
                ))}
              </Carousel>
            </div>
            <div className="rightPart">
              <h1>
                {pendingTrailData?.Title ||
                  rejectedTrailData?.Title ||
                  acceptedTrailData?.title ||
                  "-"}
              </h1>
              <div className="badgeDetail d-flex">
                <h6>
                  <span
                    className={
                      pendingTrailData?.status === "Pending"
                        ? "badge bg-yellow"
                        : rejectedTrailData?.status === "Accepted"
                        ? "badge bg-green"
                        : "badge bg-red"
                    }
                  >
                    {pendingTrailData?.status ||
                      rejectedTrailData?.status ||
                      acceptedTrailData?.status ||
                      "-"}
                  </span>
                </h6>
                <span className="ms-2">
                  {pendingTrailData?.created_at || rejectedTrailData?.created_at
                    ? format(
                        parseISO(
                          pendingTrailData?.created_at ||
                            rejectedTrailData?.created_at
                        ),
                        "yyyy-MM-dd HH:mm:ss"
                      )
                    : acceptedTrailData?.created_at}
                </span>
              </div>
              <Label className="darkLabel lable">{t("DESCRIPTION")}</Label>
              <div className="trailDescription">
                {pendingTrailData?.description ||
                  rejectedTrailData?.description ||
                  acceptedTrailData?.description ||
                  "-"}
              </div>
              <Label className="darkLabel lable">
                {t("EXPLAIN_THE_ROUTE_PATH")}
              </Label>
              <div className="trailDescription">
                {pendingTrailData?.explainRoutePath ||
                  rejectedTrailData?.explainRoutePath ||
                  acceptedTrailData?.description ||
                  "-"}
              </div>
              <div className="whiteCard">
                <div className="cardContent">
                  <div className="contentBtm">
                    <div className="dataWrapper">
                      <div className="label">{t("NAME")}</div>
                      <div className="data">
                        {pendingTrailData?.suggestedByName ||
                          rejectedTrailData?.suggestedByName ||
                          acceptedTrailData?.suggestedByName ||
                          "-"}
                      </div>
                    </div>
                    <div className="dataWrapper">
                      <div className="label">{t("EMAIL")}</div>
                      <div className="data">
                        <Label className="darkLabel lable">
                          <a
                            href={`mailto:${
                              pendingTrailData?.suggestedByEmail ||
                              rejectedTrailData?.suggestedByEmail ||
                              acceptedTrailData?.suggestedByEmail
                            }`}
                          >
                            {pendingTrailData?.suggestedByEmail ||
                              rejectedTrailData?.suggestedByEmail ||
                              acceptedTrailData?.suggestedByEmail ||
                              "-"}
                          </a>
                        </Label>
                      </div>
                    </div>
                    {(pendingTrailData?.gpxFile ||
                      rejectedTrailData?.gpxFile ||
                      acceptedTrailData?.gpx_file ||
                      pendingTrailData?.gpxFileLink ||
                      rejectedTrailData?.gpxFileLink ||
                      acceptedTrailData?.gpxFileLink) && (
                      <CustomButton
                        type="button"
                        className="btn btn-danger"
                        onClick={onGpxDownload}
                        loading={btnLoading}
                        title={
                          pendingTrailData?.gpxFile ||
                          rejectedTrailData?.gpxFile ||
                          acceptedTrailData?.gpx_file
                            ? t("DOWNLOAD_GPX")
                            : pendingTrailData?.gpxFileLink ||
                              rejectedTrailData?.gpxFileLink ||
                              acceptedTrailData?.gpx_file_link
                            ? t("VIEW_GPX")
                            : ""
                        }
                        icon={<span className="icon icon-download me-2"></span>}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div ref={mapRef} style={{ width: "100%", height: "456px" }} /> */}
        </div>

        <Modal
          isOpen={modal}
          toggle={cancelModal}
          className="mainModal"
          centered
        >
          <ModalHeader toggle={cancelModal}>{t("REJECT_TRAIL")}</ModalHeader>
          <ModalBody>
            {t(
              "ARE_YOU_SURE_YOU_WANT_TO_REJECT_THIS_TRAIL_AND_NOTIFY_THE_USER"
            )}
          </ModalBody>
          <ModalFooter>
            <CustomButton
              type="button"
              loading={loading}
              className="btn btn-danger text-white"
              onClick={onRemoveModal}
              title={t("REJECT")}
            />
            <CustomButton
              type="button"
              className="btn btn-transparent"
              onClick={cancelModal}
              title={t("CANCEL")}
            />
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default SuggestedTrailDetail;
